function fileMngrBytesToSize(bytes) {
    if (typeof bytes !== 'number' || Number.isNaN(bytes)) {
        return 'Invalid input';
    }

    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const size = bytes / 1024 ** i;
    return `${size.toFixed(2)} ${sizes[i]}`;
}

export default fileMngrBytesToSize;
